//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
export default {
  data(){
    return{
      blacklist: []
    }
  },
  mounted(){
    this.finaceList()
  },
  methods: {
    finaceList(){
      let data = 'cmd=vhost_basic&id='+this.$route.params.id;
      this.$http.post('https://api.abeiyun.com/www/vhost.php',data).then(({data})=>{
        if(data){
          this.blacklist = data.RefuseIP ? data.RefuseIP.split('#')[1].split('@') : []
        }
      })
    },
    Add() {
      let _this = this
      this.$vux.confirm.prompt('请输入添加的ip', {
        onCancel () {},
        onConfirm (value) {
          _this.blacklist.push(value)
        }
      })
      /*this.$router.push('/user/defaultsetadd/'+ this.$route.params.id)*/
    },
    IndexUp(index){
      if(index === 0){
        return false;
      }
      let temp = this.blacklist[index - 1];
      Vue.set(this.blacklist, index - 1, this.blacklist[index]);
      Vue.set(this.blacklist, index, temp);
    },
    IndexDown(index){
      if(index === this.blacklist.length - 1){
        return false;
      }
      let temp = this.blacklist[index + 1];
      Vue.set(this.blacklist, index + 1, this.blacklist[index]);
      Vue.set(this.blacklist, index, temp);
    },
    IndexDel(index) {
      this.blacklist.splice(index,1)
    },
    submit() {
      let data = 'cmd=iphmd_Set'+
        '&id='+ this.$route.params.id +
        '&ip_list='+ this.blacklist.join(',')
      let _this = this
      this.$http.post('https://api.abeiyun.com/www/vhost.php',data).then(({data})=>{
        if(data.response == 200 ) {
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/console/hostoperate/blacklist.vue